const players=[
    {
        id:1,
        name:"KWAME PEPRAH",
        position:"Forward",
        image:"peprah.webp",
    },
    {
        id:2,
        name:"DIMITRIOS DIAMANTAKOS",
        position:"Forward",
        image:"diamantakos.webp",
    },
    {
        id:3,
        name:"DAISUKE SAKAI",
        position:"Forward",
        image:"sakai.webp",
    },
    {
        id:4,
        name:"MOHAMMED AZHAR",
        position:"MIDFIELD",
        image:"azhar.webp",
    },
    {
        id:5,
        name:"YOIHENBA MEITEI",
        position:"MIDFIELD",
        image:"meitei.webp",
    },
    {
        id:6,
        name:"FREDDY LALLAWMAWMA",
        position:"MIDFIELD",
        image:"freddy.webp",
    },
    {
        id:7,
        name:"MOHAMMED ARBAZ",
        position:"GOAL KEEPER",
        image:"arbaz.webp",
    },
    {
        id:8,
        name:"LARA SHARMA",
        position:"GOAL KEEPER",
        image:"lara-sharma.webp",
    },
    {
        id:9,
        name:"SACHIN SURESH",
        position:"GOAL KEEPER",
        image:"sachin.webp",
    },
    {
        id:10,
        name:"VIBIN MOHANAN",
        position:"MIDFIELD",
        image:"vibin.webp",
    },
    {
        id:11,
        name:"SAURAV MANDAL",
        position:"FORWARD",
        image:"mandal.webp",
    },
    {
        id:12,
        name:"BRYCE MIRANDA",
        position:"FORWARD",
        image:"miranda.webp",
    },
    {
        id:13,
        name:"SANDEEP SINGH",
        position:"DEFENSE",
        image:"sandeep.webp",
    },
    {
        id:14,
        name:"MARKO LESKOVIC",
        position:"DEFENSE",
        image:"leskovic.webp",
    },
    {
        id:15,
        name:"RAHUL KP",
        position:"FORWARD",
        image:"rahul.webp",
    },
    {
        id:16,
        name:"ADRIAN LUNA (C)",
        position:"MIDFIELD",
        image:"luna.webp",
    },
    {
        id:17,
        name:"JEAKSON SINGH",
        position:"MIDFIELD",
        image:"jeakson.webp",
    },
    {
        id:18,
        name:"RUIVAH HORMIPAM",
        position:"DEFENSE",
        image:"ruivah.webp",
    },
]

export default players